<template>
    <!-- <div class="home"> -->
      <TarckHomePages />
    <!-- </div> -->
  </template>
  
  <script>
  // @ is an alias to /src
  import TarckHomePages from '@/components/Track/TrackHomePage.vue'
  
  export default {
    name: 'TrackingView',
    components: {
      TarckHomePages
    }
  }
  </script>
  